import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const LoadingIndicator = ({ message }) => (
  <CenterScreen>
    <div>
      <StyledSpinner>
        <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="4" />
      </StyledSpinner>
      <LoadingMessage>{message}</LoadingMessage>
    </div>
  </CenterScreen>
);

const LoadingMessage = styled.span`
  padding-left: 2rem;
  font-size: larger;
`;

const CenterScreen = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 100vh;
`;
const StyledSpinner = styled.svg`
  animation: rotate 2s linear infinite;
  width: 50px;
  height: 50px;
  margin: auto;

  & .path {
    stroke: #f2200d;
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }
  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }
`;

export default LoadingIndicator;

LoadingIndicator.propTypes = {
  message: PropTypes.string,
};
